module.exports = __webpack_public_path__ + "img/brian-ford-logo-white.51ab16b7.png";